import * as TermQueries from "../../templates/term-queries";
import {bool} from "../../templates/compound-queries";
import * as FtsQueries from "../../templates/fts-queries";
import {relationsByIdQuery} from "./relations-query-partial-builder";

export const conceptQuery = (conceptVar: string, relations: Array<string>): string => {
  const ids = TermQueries.ids({values: conceptVar, boost: 100});
  const multiMatch = FtsQueries.multiMatch({query: conceptVar, analyzer: 'keyword'});
  const relationsBlock = relationsByIdQuery(relations, conceptVar);
  return bool.should(`
    # EXACT match for the concept
    ${ids},
    # Text mentions of the concept's id
    ${multiMatch},
    # Related objects
    ${relationsBlock}
  `);
};
